/**
 * Helper utilities for Emission modules to correctly map client filters and vessels.
 * Specifically, Llevant (IMO 9399480) and Vendavel (IMO 9432048) are EMZoil vessels
 * that may have historical records tagged under Eiger in legacy tables.
 */

export const EMZOIL_OVERRIDE_IMOS = ['9399480', '9432048'];
export const EMZOIL_OVERRIDE_NAMES = ['llevant', 'vendavel'];

export function isEmzoilVessel(item: any): boolean {
  if (!item) return false;
  const imo = String(item.imo_number ?? item.ship_imo ?? item.imo ?? item.original_vessel_imo ?? '').trim();
  const name = String(item.vessel_name ?? item.ship_name ?? item.vessel ?? '').trim().toLowerCase();
  return EMZOIL_OVERRIDE_IMOS.includes(imo) || EMZOIL_OVERRIDE_NAMES.includes(name);
}

export function normalizeEmissionVesselClient(item: any): void {
  if (!item) return;
  if (isEmzoilVessel(item)) {
    item.client_name = 'EMZOIL FZCO';
  }
}
